module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoreFeatures),
      expression: "showMoreFeatures"
    }],
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row web-features",
    staticStyle: {
      "border": "1px solid #1E70EC",
      "font-family": "'Roboto', 'Open Sans', sans-serif"
    }
  }, [_c('span', _vm._l((_vm.widgets), function(indicator_value, key) {
    return _c('div', {
      key: key,
      staticClass: "col-xs-12 col-sm-6 col-md-4"
    }, [_c('div', {
      staticClass: "panel panel-primary widget",
      attrs: {
        "id": 'widget_' + key
      }
    }, [_c('div', {
      staticClass: "panel-heading bg-primary"
    }, [_c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: ('drag'),
        expression: "'drag'",
        modifiers: {
          "top": true
        }
      }],
      staticClass: "glyphicon glyphicon-stats",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "pull-right widget-tools"
    })]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    })])])
  })), _vm._v(" "), _c('v-speed-dial', {
    attrs: {
      "top": false,
      "bottom": true,
      "right": true,
      "left": false,
      "fixed": false,
      "absolute": false,
      "direction": 'top',
      "open-on-hover": false,
      "transition": _vm.transition
    },
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "indigo darken-2",
      "dark": "",
      "fab": "",
      "ripple": false
    },
    on: {
      "click": function($event) {
        _vm.addWidget()
      }
    },
    slot: "activator",
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bg-primary"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('h4', [_vm._v("\n          Micro level analysis "), _c('small', [_vm._v("create a widget to make analysis")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_vm._v("\n        Indicator selection here\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_vm._v("\n        Data source selection here\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_vm._v("\n        Select period here\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f1f3074","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboards/car/components/widgetContainer.vue
// module id = 961
// module chunks = 0